module.exports = __webpack_public_path__ + "img/icon_shopping_greyed.536cd5f3.png";